import React from 'react'
// libs
import { change } from 'redux-form'
import { useDispatch } from 'react-redux'
// constants
import { Forms } from 'constants/index'
// components
import { ReduxSwitch } from 'components/FormElements'
// types
import { IField, IRiskTemplate } from 'types/graphql'

interface Props {
  field: IField
  parentId?: string
  isRelated: boolean
  riskTemplate: IRiskTemplate
}

const Field: React.FC<Props> = ({ field, parentId = null, isRelated, riskTemplate }) => {
  const dispatch = useDispatch()

  const onChange = (_e: React.ChangeEvent, value: boolean) => {
    dispatch(
      change(Forms.RISK_VIEW_FORM, `fields.${field.id}`, {
        active: value,
        fieldId: field.id,
        parentFieldId: parentId,
        ...(isRelated && { riskTemplateId: riskTemplate.id })
      })
    )
  }

  return (
    <ReduxSwitch
      label={field.label}
      name={`fields.${field.id}.active`}
      listenOnChange={onChange}
      justifyContent='space-between'
    />
  )
}

export default Field
